/**
 * Image
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
import { Icon } from 'ui-component-library/base';
/** The image component with or without the figure caption. */
var Image = function (_a) {
    var src = _a.src, _b = _a.alt, alt = _b === void 0 ? '' : _b, className = _a.className, figCaption = _a.figCaption, zoomIcon = _a.zoomIcon, toggleModal = _a.toggleModal, largeSrc = _a.largeSrc, openBtnLabel = _a.openBtnLabel, _c = _a.size, size = _c === void 0 ? 'default' : _c, htmlAttributes = __rest(_a, ["src", "alt", "className", "figCaption", "zoomIcon", "toggleModal", "largeSrc", "openBtnLabel", "size"]);
    if (!src) {
        return null;
    }
    var renderZoomBtn = function () {
        return (React.createElement("button", { onClick: function (e) {
                e.preventDefault();
                toggleModal(largeSrc, alt);
            }, className: "group block focus:outline-none imagemodal__btn--zoomin", "aria-label": openBtnLabel },
            React.createElement(Icon, { icon: "zoomIn", size: 5, className: clsx(figCaption ? 'mb-3' : 'mb-6', 'absolute bottom-0 right-0 p-3 mr-3 cursor-pointer group-focus:border-blue group-focus:border-2') })));
    };
    return (React.createElement(React.Fragment, null,
        (!figCaption || figCaption.length <= 1) && (React.createElement("div", { className: clsx(size === 'medium' && 'lg:-mx-8', size === 'large' && 'lg:-mx-24', 'relative') },
            React.createElement("img", __assign({ src: src, alt: alt, className: clsx(className, 'w-full mb-4 image__object-fit'), "data-cid": "Image" }, htmlAttributes)),
            zoomIcon && renderZoomBtn())),
        figCaption && figCaption.length > 1 && (React.createElement("figure", { "data-cid": "Image", className: clsx(size === 'medium' && 'lg:-mx-8', size === 'large' && 'lg:-mx-24', 'mb-4') },
            React.createElement("div", { className: "relative" },
                React.createElement("img", __assign({ src: src, alt: alt, className: clsx(className, 'w-full image__object-fit') }, htmlAttributes)),
                zoomIcon && renderZoomBtn()),
            React.createElement("figcaption", { className: clsx('bg-white', 'py-2', 'px-3', 'leading-6') }, figCaption)))));
};
export default Image;
